window.marketoInit = (...args) => {
  window.addEventListener('DOMContentLoaded', () => {
    marketoRelay(...args)
  })
}